import { FC } from 'react';
import { useField } from 'formik';
import styles from '../contactForm/contactForm.module.css';

interface MultiCheckboxListProps {
    name: string;
    options: { key: string; label: string }[];
}

export const MultiCheckboxList: FC<MultiCheckboxListProps> = ({
    name,
    options,
}) => {
    const [field, , helpers] = useField(name);
    const { setValue } = helpers;

    return (
        <div className={styles.checkboxList}>
            {options.map(({ key, label }) => {
                const fieldValue: string[] = Array.isArray(field.value)
                    ? field.value
                    : [];
                const isChecked = fieldValue.includes(label);

                const handleCheckboxChange = () => {
                    const updatedValue = isChecked
                        ? fieldValue.filter((item) => item !== label)
                        : [...fieldValue, label];

                    setValue(updatedValue);
                };

                return (
                    <label key={key} className={styles.checkboxLabel}>
                        <input
                            type="checkbox"
                            name={name}
                            value={label}
                            checked={isChecked}
                            onChange={handleCheckboxChange}
                        />
                        {label}
                    </label>
                );
            })}
        </div>
    );
};
